// src/components/FormSection.jsx
import React, { useRef, useState } from "react";
import { firestore } from "../admin/FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { FaUser, FaEnvelope, FaCommentDots, FaPhoneAlt, FaCheck } from "react-icons/fa";
import { SiBentobox } from "react-icons/si";

const FormSection = () => {
  const form = useRef();
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(form.current);
    const data = {
      product: formData.get("product"),
      name: formData.get("name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      message: formData.get("message"),
      timestamp: new Date(),
    };

    try {
      const docRef = await addDoc(collection(firestore, "inquiries"), data);
      console.log("Document written with ID: ", docRef.id);
      setSuccess(true);
      form.current.reset();
      setTimeout(() => setSuccess(false), 5000);
    } catch (error) {
      console.error("Error adding document: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const iconStyle = { color: "#ffd700", position: "absolute", top: "15px", left: "15px" };

  const inputStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 215, 0, 0.3)",
    color: "#918e8eff",
    padding: "12px 15px 12px 45px",
    borderRadius: "8px",
    transition: "all 0.3s",
    width: "100%"
  };

  const submitButtonStyle = {
    background: "linear-gradient(135deg, #ffd700, #ff8c00)",
    color: "#000",
    border: "none",
    padding: "12px 30px",
    borderRadius: "50px",
    fontWeight: "600",
    transition: "all 0.3s",
    boxShadow: "0 5px 15px rgba(255, 215, 0, 0.4)",
    width: "100%"
  };

  return (
    <div style={{
      background: "linear-gradient(135deg, rgba(0,0,0,0.85), rgba(40,40,40,0.95))",
      borderRadius: "15px",
      padding: "30px",
      boxShadow: "0 15px 30px rgba(0,0,0,0.4)",
      border: "1px solid rgba(255,215,0,0.2)"
    }}>
      <div className="text-center mb-4">
        <h2 style={{ color: "#ffd700", fontWeight: 700, marginBottom: "10px", fontSize: "1.7rem" }}>
          Get Started Today
        </h2>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem" }}>
          Provide some details & we’ll guide you to the right solution.
        </p>
      </div>

      <form ref={form} onSubmit={handleSubmit}>
        <div className="mb-3 position-relative">
          <SiBentobox style={iconStyle} />
          <select name="product" style={inputStyle} required>
            <option value="">Choose a Product</option>
            <option value="Loan Against Property">Loan Against Property</option>
            <option value="Digital business loan">Digital business loan</option>
            <option value="Education Loan Against Bond">Education Loan Against Bond</option>
            <option value="Life Insurance">Life Insurance</option>
            <option value="Health Insurance">Health Insurance</option>
            <option value="Motor Insurance">Motor Insurance</option>
            <option value="Travel Insurance">Travel Insurance</option>
            <option value="Mutual Funds">Mutual Funds</option>
            <option value="Stock & Securities">Stock & Securities</option>
            <option value="Tax Planning">Tax Planning</option>
            <option value="DigiGold">DigiGold</option>
          </select>
        </div>

        <div className="mb-3 position-relative">
          <FaUser style={iconStyle} />
          <input type="text" name="name" style={inputStyle} placeholder="Enter your name" required />
        </div>

        <div className="mb-3 position-relative">
          <FaEnvelope style={iconStyle} />
          <input type="email" name="email" style={inputStyle} placeholder="Enter your email" required />
        </div>

        <div className="mb-3 position-relative">
          <FaPhoneAlt style={iconStyle} />
          <input type="tel" name="phone" style={inputStyle} placeholder="Enter mobile number" pattern="[0-9]{10}" required />
        </div>

        <div className="mb-3 position-relative">
          <FaCommentDots style={iconStyle} />
          <textarea name="message" style={{ ...inputStyle, height: "80px" }} placeholder="Tell us your requirements..." required></textarea>
        </div>

        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" id="termsCheck" required />
          <label className="form-check-label" htmlFor="termsCheck" style={{ color: "rgba(255,255,255,0.8)" }}>
            I agree to the terms & conditions
          </label>
        </div>

        <div className="text-center mt-3">
          <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Processing...
              </>
            ) : (
              <>
                <FaCheck className="me-2" /> Submit Request
              </>
            )}
          </button>

          {success && (
            <div className="alert alert-success mt-3" style={{
              backgroundColor: "rgba(25, 135, 84, 0.9)",
              border: "none",
              color: "white",
              borderRadius: "8px"
            }}>
              <strong>Success!</strong> Form submitted successfully. We’ll contact you soon.
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default FormSection;
